import { Navbar } from '@/components/layout/Navbar';
import { Footer } from '@/components/layout/Footer';
import { HeroSection } from '@/components/home/HeroSection';
import { AgencyEngineSection } from '@/components/home/AgencyEngineSection';
import { TalentMarquee } from '@/components/home/TalentMarquee';
import { WhySection } from '@/components/home/WhySection';
import { HowItWorksSection } from '@/components/home/HowItWorksSection';
import { TestimonialsSection } from '@/components/home/TestimonialsSection';
import { PricingSection } from '@/components/home/PricingSection';
import { FinalCTASection } from '@/components/home/FinalCTASection';

export default function HomePage() {
  return (
    <div className="bg-background min-h-screen overflow-x-hidden">
      <Navbar />
      <main>
        <HeroSection />
        <TalentMarquee />
        <AgencyEngineSection />
        <WhySection />
        <HowItWorksSection />
        <TestimonialsSection />
        <PricingSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}
